import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Textarea,
  Button,
  VStack,
  Fade,
  useDisclosure,
  Heading,
  Flex
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloat = () => {
  const { isOpen, onToggle } = useDisclosure();
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me//558185771555?text=${encodedMessage}`, '_blank');
    setMessage('');
    onToggle();
  };

  return (
    <Box position="fixed" bottom="6" right="6" zIndex={1000}>
      <Fade in={isOpen}>
        <Box
          position="absolute"
          bottom="20"
          right="0"
          mb={2}
          width="300px"
          bg="white"
          borderRadius="lg"
          boxShadow="xl"
          p={4}
          border="1px"
          borderColor="gray.200"
        >
          <form onSubmit={handleSubmit}>
            <VStack spacing={3} align="stretch">
              <Flex justify="space-between" align="center">
                <Heading size="sm" color="#25D366">
                  Enviar mensagem
                </Heading>
                <IconButton
                  size="sm"
                  icon={<CloseIcon />}
                  onClick={onToggle}
                  variant="ghost"
                  aria-label="Fechar"
                />
              </Flex>
              
              <Textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Digite sua mensagem..."
                size="sm"
                resize="none"
                height="100px"
                focusBorderColor="#25D366"
              />
              
              <Button
                type="submit"
                bg="#25D366"
                color="white"
                width="full"
                _hover={{ bg: "#20ba57" }}
                leftIcon={<FaWhatsapp size={28} />}
              >
                Enviar
              </Button>
            </VStack>
          </form>
        </Box>
      </Fade>

      <IconButton
        onClick={onToggle}
        icon={isOpen ? <CloseIcon /> : <FaWhatsapp size={28} />}
        bg="#25D366"
        color="white"
        _hover={{ bg: "#20ba57" }}
        boxSize="16"
        borderRadius="full"
        boxShadow="lg"
        aria-label="Abrir WhatsApp"
        transform={isOpen ? "rotate(180deg)" : "none"}
        transition="all 0.3s"
      />
    </Box>
  );
};

export default WhatsAppFloat;